<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>Pillars of Cloud and Fire</h1>
<h1 class="bk1">The Politics of Exodus in African American Biblical Interpretation</h1>
<p class="bkau">Herbert Robinson Marbury</p>
<p class="bkpub"><img alt="" height="44" src="images/NYU_TitlePage_Logo.jpg" width="35"/></p>
<p class="bkpub">NEW YORK UNIVERSITY PRESS</p>
<p class="bkpub1">New York and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Marbury-0003.vue?1b549ab8